module.exports = __webpack_public_path__ + "static/media/gr-04.10bea1fe.png";